import { Pie } from "react-chartjs-2";

export const options = {
  responsive: true,
  legend: {
    position: "bottom",
  },
};

export const data = {
  labels: ["Last Week", "Last Month", "Last 3 Months"],
  datasets: [
    {
      label: "# of Votes",
      data: [12, 19, 3],
      backgroundColor: [
        "rgba(255, 99, 132, 0.6)",
        "rgba(75, 192, 192, 0.6)",
        "rgba(54, 162, 235, 0.6)",
      ],
      borderColor: [
        "rgba(255, 99, 132, 1)",
        "rgba(75, 192, 192, 1)",
        "rgba(54, 162, 235, 1)",
      ],
      borderWidth: 1,
    },
  ],
};

function PieChart() {
  return <Pie data={data} options={options} />;
}

export default PieChart;
